var defaultCurrencyFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
});
var toSafeString = function (value) {
    if (typeof value !== "string") {
        return "";
    }
    return value.trim();
};
var toProperCase = function (value) {
    var safeValue = toSafeString(value);
    if (!safeValue) {
        return "";
    }
    var words = safeValue.split(" ");
    var formattedWords = [];
    for (var _i = 0, words_1 = words; _i < words_1.length; _i++) {
        var word = words_1[_i];
        if (!word) {
            continue;
        }
        var firstCharacter = word.slice(0, 1).toUpperCase();
        var remainingCharacters = word.slice(1).toLowerCase();
        formattedWords.push("".concat(firstCharacter).concat(remainingCharacters));
    }
    return formattedWords.join(" ");
};
var toSentenceCase = function (value) {
    var safeValue = toSafeString(value);
    if (!safeValue) {
        return "";
    }
    var firstCharacter = safeValue.slice(0, 1).toUpperCase();
    var remainingCharacters = safeValue.slice(1).toLowerCase();
    return "".concat(firstCharacter).concat(remainingCharacters);
};
var toUpperCase = function (value) {
    return toSafeString(value).toUpperCase();
};
var toCurrency = function (value) {
    var numericValue = typeof value === "string" ? Number(value) : value !== null && value !== void 0 ? value : 0;
    if (Number.isNaN(numericValue)) {
        return defaultCurrencyFormatter.format(0);
    }
    return defaultCurrencyFormatter.format(numericValue);
};
var removeTrailingAsterisk = function (value) {
    var safeValue = toSafeString(value);
    if (!safeValue) {
        return "";
    }
    var formattedValue = safeValue;
    while (formattedValue.endsWith("*")) {
        formattedValue = formattedValue.slice(0, -1).trimEnd();
    }
    return formattedValue;
};
export var formatter = {
    toProperCase: toProperCase,
    toUpperCase: toUpperCase,
    toCurrency: toCurrency,
    toSentenceCase: toSentenceCase,
    removeTrailingAsterisk: removeTrailingAsterisk
};
